"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listUnstyled = listUnstyled;
exports.listInline = listInline;
exports.listInlineItem = listInlineItem;
exports.default = exports.defaultProps = void 0;
var defaultProps = {
  '$list-inline-padding': '5px'
};
/**
 * @public
 * @description Unstyled keeps list items block level, just removes default browser padding and list-style.
 * @returns {string}
 */

exports.defaultProps = defaultProps;

function listUnstyled() {
  return "\n    padding-left: 0;\n    list-style: none;\n  ";
}

function listInline() {
  return listUnstyled();
}
/**
 * @public
 * @description Inline list and removes margin for last child.
 * @param listInlinePadding
 * @returns {string}
 */


function listInlineItem() {
  var listInlinePadding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$list-inline-padding'];
  return "\n    display: inline-block;\n  \n    &:not(:last-child) {\n      margin-right: ".concat(listInlinePadding, ";\n    }\n  ");
}

var _default = {
  defaultProps: defaultProps,
  listInline: listInline,
  listUnstyled: listUnstyled
};
exports.default = _default;